import { Card, Tag, Typography } from 'antd';

const { Meta } = Card;
const { Text, Paragraph } = Typography;
interface TicketCardProps {
    ticketKey: string;
    title: string;
    description: string;
    isSelected: boolean;
    onClickAction?: (ticketKey: string) => void;
}

const styles = {
    tag: {
        minWidth: '100px',
        display: 'flex',
        justifyContent: 'center'
    },
    cardBody: {
        padding: '1rem'
    },
    title: {
        fontSize: '14px'
    },
    avatar: {
        marginTop: '6px',
        paddingRight: 0
    }
};

const TicketCard = ({ ticketKey, title, description, isSelected, onClickAction }: TicketCardProps) => {
    return (
        <Card
            className="ticket-card"
            bodyStyle={styles.cardBody}
            hoverable={!isSelected}
            bordered={isSelected}
            onClick={() => (onClickAction ? onClickAction(ticketKey) : null)}
        >
            <Meta
                avatar={
                    <div style={styles.avatar}>
                        <Tag style={styles.tag} color="#632d91">{`#${ticketKey?.split('-')?.[1]}`}</Tag>
                    </div>
                }
                title={
                    <Text style={styles.title} type="secondary">
                        {title}
                    </Text>
                }
                description={
                    <Paragraph strong ellipsis={{ rows: 2, expandable: true, symbol: 'expand' }}>
                        {description}
                    </Paragraph>
                }
            />
        </Card>
    );
};

export default TicketCard;
